
export const canChangeCities = (user) => {
  return !user.jugnoId;
};

export const hasJugnoRestriction = (user) => {
  return !!user.jugnoId;
};

export const canAccessCity = (user, cityId) => {
  if (!user.jugnoId) {
    return true;
  }
  return user.cityId === cityId;
};
